import { MpFile } from '@borg/types';

class MyDocumentsRepository extends Repository<MpFile> {
  override getMany() {
    return this._getMany({ url: '/documents' });
  }

  override create(data: MpFile) {
    return this._create({ url: '/documents', data: { id: data.id } });
  }

  override update(data: Partial<MpFile>) {
    const { id, ...patchData } = data;
    return this._update({ url: `/documents/${id}`, data: patchData });
  }

  override delete(id: MpFile['id']) {
    return this._delete({ url: `/documents/${id}` });
  }
}

export const myDocumentsRepository = new MyDocumentsRepository();
